// extracted by mini-css-extract-plugin
module.exports = {"canvasWrap":"tower-config_canvasWrap_37xCo"};